<template>
  <van-popover
    v-model="showPopover"
    placement="top-start"
    theme="dark"
    :offset="[-9, 8]"
  >
    <slot />
    <template #reference>
      <img @click="showPopover = !showPopover" class="popover-icon" src="@/assets/share/info-circle.png" >
    </template>
  </van-popover>
</template>

<script>
import { Popover } from '@zyf2e/capui-mobile';
import '@zyf2e/capui-mobile/lib/popover/style';

export default {
  components: {
    VanPopover: Popover
  },
  props: {},
  data() {
    return {
      showPopover: false
    };
  }
};
</script>

<style lang="less">
.van-popover__wrapper {
  display: flex;
  align-content: center;
}

.van-popover--light {
  max-width: 240px;
}

.van-popover__content {
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.8) !important;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 18px;
  width: 160px;
}

.popover-icon {
  width: 14px;
  height: 14px;
}
</style>
